import { render } from "./xunjianadd.vue?vue&type=template&id=62c6d0db&scoped=true&ts=true"
import script from "./xunjianadd.vue?vue&type=script&lang=ts"
export * from "./xunjianadd.vue?vue&type=script&lang=ts"

import "./xunjianadd.vue?vue&type=style&index=0&id=62c6d0db&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c6d0db"]])

export default __exports__